export default __webpack_public_path__ + "media/images/react_icons/paint_roller_landlord-d1ca886b8ae0bc69b995afa04d4ed4b1.svg";